module.exports = __webpack_public_path__ + "img/232.refrigerator.1f54b731.svg";